import React from "react";

function Footer(props) {
  return (
    <div>
      <div className={"footer-placement"}></div>
      <div className={"fixed-bottom footer"}>
        {!props.isMobile && (
          <>
            <div className={"d-flex gap-2"}>
              <a
                href="https://www.facebook.com/ArigBankMN/"
                target="_blank"
                rel="noreferrer"
              >
                <img src="./social/facebook.png" alt="facebook" />
              </a>
              <a
                href="https://www.instagram.com/arigbank"
                target="_blank"
                rel="noreferrer"
              >
                <img src="./social/instagram.png" alt="instagram" />
              </a>
              <a
                href="https://twitter.com/arigbankm"
                target="_blank"
                rel="noreferrer"
              >
                <img src="./social/twitter.png" alt="twitter" />
              </a>
              <a
                href="https://www.youtube.com/channel/UC8Mdr1E5ZseQbQjMBQjk8Hg"
                target="_blank"
                rel="noreferrer"
              >
                <img src="./social/youtube.png" alt="youtube" />
              </a>
              <a
                href="https://mn.linkedin.com/company/arig-bank-of-mongolia"
                target="_blank"
                rel="noreferrer"
              >
                <img src="./social/linkedin1.png" alt="linkedin1" />
              </a>
            </div>
            <div className={"bottom-img d-flex gap-2"}>
              <a
                href="https://apps.apple.com/us/app/arig-online/id6444022675?platform=iphone"
                target="_blank"
                rel="noreferrer"
              >
                <img src="./social/appstore.png" alt="appstore" />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=mn.arig.online&hl=en&gl=US&pli=1"
                target="_blank"
                rel="noreferrer"
              >
                <img src="./social/googleplay.png" alt="googleplay" />
              </a>
              <img src="./social/ISO.png" alt="ISO" />
            </div>
          </>
        )}

        {props.isMobile && (
          <div className={"d-flex gap-2"}>
            <a
              href="https://www.facebook.com/ArigBankMN/"
              target="_blank"
              rel="noreferrer"
            >
              <img src="./social/facebook.png" alt="moblefb" />
            </a>
            <a
              href="https://www.instagram.com/arigbank"
              target="_blank"
              rel="noreferrer"
            >
              <img src="./social/instagram.png" alt="mobileig" />
            </a>
            <a
              href="https://twitter.com/arigbankm"
              target="_blank"
              rel="noreferrer"
            >
              <img src="./social/twitter.png" alt="mobiletwitter" />
            </a>
            <a
              href="https://www.youtube.com/channel/UC8Mdr1E5ZseQbQjMBQjk8Hg"
              target="_blank"
              rel="noreferrer"
            >
              <img src="./social/youtube.png" alt="myoutube" />
            </a>
            <a
              href="https://mn.linkedin.com/company/arig-bank-of-mongolia"
              target="_blank"
              rel="noreferrer"
            >
              <img src="./social/linkedin1.png" alt="mlinkedin1" />
            </a>
          </div>
        )}
      </div>
    </div>
  );
}

export default Footer;
